import Vue from 'vue'
import Vant from 'vant'
import { Lazyload } from 'vant';

Vue.use(Lazyload);
Vue.use(Vant)
